import Notiflix from "notiflix";
import React, { Component } from "react";
import {
  Card,
  CardBody, Col, Container,
  Row
} from "reactstrap";
import PostApiCall from "../../Api";
import Breadcrumbs from "../../components/Common/Breadcrumb";

import moment from "moment";


import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-responsive-modal/styles.css";
import "./ChitsDashboard.css";

export default class ChitsDashboard extends Component {
  state = {
    ChitSchema: [],
    Details: [],
    searchInput: "",
    Scheme: "",
    open: false,
    SchemaData: [
      { label: "Select Jewel Scheme", value: "Select Jewel Scheme" },
      { label: "Thanga Mazhai", value: "Thanga Mazhai" },
      { label: "My Gold Eleven", value: "My Gold Eleven" },
    ],
    ChitAmount: "",
    installementnumber: "",
    Transactions: [],
    TransactionId: "",
    Chitamounts: "",
    paidOn: ""
  };

  componentDidMount = () => {
    Notiflix.Loading.Init({
      svgColor: "#880105",
    });

    Notiflix.Loading.Dots("Please wait...");

    var det = localStorage.getItem("LoginDetail");
    var detail = JSON.parse(det);
    this.setState({
      Details: detail[0],
    });



    PostApiCall.postRequest(
      {
        id: detail[0].fld_id,
      },
      "Get_Client_ChitScheme"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          this.setState({
            ChitSchema: obj.data,
          });


        }
      })
    );

    Notiflix.Loading.Remove();
  };

  seachBarHandler = (e) => {
    this.setState({ ...this.state, searchInput: e.target.value });
  };


  render() {
    return (
      <React.Fragment>
        {/* chitDash-phnview class add by laxmi---------------------------------for remove extra left/right padding phn view */}
        <div className="page-content chitDash-phnview">
          <Container fluid className="chitDash-phnview chitsMargintop p-0">
            <div className="px-3">
              <Breadcrumbs
                title={"Shanthi Jewellers"}
                breadcrumbItem={"Dashboard"}
              />
            </div>
            {/* Render Breadcrumb */}

            <React.Fragment>
              <div className="page-content p-0 m-0">
                <div className="container-fluid">
                  <h4>Welcome {this.state.Details.fld_name}</h4>
                  <Row>
                    <Col className="col-12">
                      <Card
                        style={{
                          background: "rgba(136, 1, 5, 0.3)",
                          border: "1px solid #880105",
                        }}
                      >
                        <CardBody>
                          <div className="row">
                            {/* div class chnage and fontDhitdashDetail add by laxmi for phn , tab view------------------------------ */}
                            {/* <div className="col-6"> */}
                            <div className="col-12 col-sm-12 col-lg-6">
                              <p
                                className="fontDhitdashDetail"
                                style={{ fontSize: "15px", color: "#880105" }}
                              >
                                Name :
                                <span
                                  style={{ color: "#fff", marginLeft: "3px" }}
                                >
                                  {this.state.Details.fld_name}
                                </span>
                              </p>
                            </div>
                            {/* div class chnage and fontDhitdashDetail add by laxmi for phn , tab view------------------------------ */}
                            {/* <div className="col-6"> */}
                            <div className="col-12 col-sm-12 col-lg-6">
                              <p
                                className="fontDhitdashDetail"
                                style={{ fontSize: "15px", color: "#880105" }}
                              >
                                Email :
                                <span
                                  style={{ color: "#fff", marginLeft: "3px" }}
                                >
                                  {this.state.Details.fld_email}
                                </span>
                              </p>
                            </div>
                            {/* div class chnage and fontDhitdashDetail add by laxmi for phn , tab view------------------------------ */}
                            {/* <div className="col-6"> */}
                            <div className="col-12 col-sm-12 col-lg-6">
                              <p
                                className="fontDhitdashDetail"
                                style={{ fontSize: "15px", color: "#880105" }}
                              >
                                Mobile :
                                <span
                                  style={{ color: "#fff", marginLeft: "3px" }}
                                >
                                  {this.state.Details.fld_mobile}
                                </span>
                              </p>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <Card className="overflow-hidden">
                    <div
                      className="maxXchange-bg-soft-pink"
                      style={{ background: "rgb(171, 61, 0)" }}
                    >
                      <Row>
                        {/* class size change by laxmi---------------------------------- */}
                        {/* <Col xs="6"> */}
                        <Col xs="12" sm="12" md="6" lg="12">
                          <div className="maxXchange-text p-3">
                            <h5 className="maxXchange-text">
                              Jewel Saving Scheme
                            </h5>
                          </div>
                        </Col>

                        <Col xs="2"></Col>
                      </Row>
                    </div>

                    {/* Replace table to card- */}
                    <CardBody className="pt-3">
                      <Row>
                        {this.state.ChitSchema.map((data, i) => {
                          return (
                            <Col className="col-12 col-md-6 col-lg-4 col-xl-3 cardHome">
                              <Card
                                className="phnviewmarginchitdash"
                                style={{
                                  background: "rgba(136, 1, 5, 0.3)",
                                  border: "1px solid #880105",
                                }}
                              >
                                <CardBody>
                                  {/* div class chnage and fontDhitdashDetail add by laxmi for phn , tab view------------------------------ */}
                                  {/* <div className="col-6"> */}

                                  <div className="row">
                                    <div className="col-12 col-sm-12 col-lg-12">
                                      <div className="row">
                                        <div className="col-6 col-md-6 ">
                                          <b> S.NO</b>
                                        </div>
                                        <div className="col-6 col-md-6">
                                          {i + 1}
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-6 col-md-6">
                                          <b>Name</b>
                                        </div>
                                        <div className="col-6 col-md-6">
                                          {data.fld_name}
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-6 col-md-6">
                                          <b>Book No</b>
                                        </div>
                                        <div className="col-6 col-md-6">
                                          {data.fld_accountno}
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-6 col-md-6">
                                          <b>Chit Scheme</b>
                                        </div>
                                        <div className="col-6 col-md-6">
                                          {data.fld_chitschema}
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-6 col-md-6">
                                          <b>Amount</b>
                                        </div>
                                        <div className="col-6 col-md-6">
                                          {data.fld_chitamount}
                                        </div>
                                      </div>

                                      <div className="row">
                                        <div className="col-6 col-md-6 mt-3">
                                          <button
                                            className={"btn "}
                                            type="submit"
                                            style={{
                                              backgroundColor: "#880105",
                                              color: "#e1b761"
                                            }}

                                            onClick={() => {
                                              PostApiCall.postRequest(
                                                {
                                                  accountnumber: data.fld_accountno,
                                                },
                                                "Get_Latest_TransactionData"
                                              ).then((results2) =>
                                                results2.json().then((obj2) => {
                                                  if (results2.status == 200 || results2.status == 201) {
                                                    // console.log(obj2.data);
                                                    try {
                                                      if (obj2.data != null) {
                                                        confirmAlert({

                                                          title: "You have attempted payment on " + obj2.data[0].paiddate + ". Are you sure you want to make another payment?",
                                                          message: "",
                                                          buttons: [
                                                            {
                                                              label: "Yes",
                                                              onClick: () => {
                                                                Notiflix.Loading.Dots(
                                                                  "Please wait..."
                                                                );
                                                                PostApiCall.postRequest(
                                                                  {
                                                                    accountno: data.fld_accountno,
                                                                    paidamount: data.fld_chitamount,
                                                                    status: "Pending",
                                                                    paiddate:
                                                                      moment().format("lll"),
                                                                    chitSchema_id: data.fld_id,
                                                                    installment_id: i + 1,
                                                                    list: "Show",
                                                                  },
                                                                  "Add_Transaction"
                                                                ).then((result) =>
                                                                  result.json().then((obj) => {
                                                                    if (
                                                                      result.status === 200 ||
                                                                      result.status === 201
                                                                    ) {
                                                                      Notiflix.Loading.Remove();
                                                                      localStorage.setItem("trxid", obj.data[0].Transactionid);
                                                                      window.open(
                                                                        data.payment_link, "_self")
                                                                    } else {
                                                                      Notiflix.Loading.Remove();
                                                                      Notiflix.Loading.Failure(
                                                                        obj.data
                                                                      );
                                                                    }
                                                                  })
                                                                );
                                                              },
                                                            },
                                                            {
                                                              label: "No",
                                                              // onClick: () => alert('Click No')
                                                            },
                                                          ],
                                                        });
                                                      }
                                                    }
                                                    catch {
                                                      PostApiCall.postRequest(
                                                        {
                                                          accountno: data.fld_accountno,
                                                          paidamount: data.fld_chitamount,
                                                          status: "Pending",
                                                          paiddate:
                                                            moment().format("lll"),
                                                          chitSchema_id: data.fld_id,
                                                          installment_id: i + 1,
                                                          list: "Show",
                                                        },
                                                        "Add_Transaction"
                                                      ).then((result) =>
                                                        result.json().then((obj) => {
                                                          if (
                                                            result.status === 200 ||
                                                            result.status === 201
                                                          ) {
                                                            Notiflix.Loading.Remove();
                                                            localStorage.setItem("trxid", obj.data[0].Transactionid);
                                                            window.open(
                                                              data.payment_link, "_self")
                                                          } else {
                                                            Notiflix.Loading.Remove();
                                                            Notiflix.Loading.Failure(
                                                              obj.data
                                                            );
                                                          }
                                                        })
                                                      );
                                                    }
                                                  }

                                                }))
                                            }}


                                          >Pay Now</button>
                                        </div>
                                        <div className="col-6 col-md-6 mt-3">
                                          <button
                                            className={"btn "}
                                            type="submit"
                                            style={{
                                              backgroundColor: "#880105",
                                              color: "#e1b761"
                                            }}
                                            onClick={() => {
                                              confirmAlert({
                                                title: "Confirm to Close Account",
                                                message:
                                                  "Are you sure you want to close your account.",
                                                buttons: [
                                                  {
                                                    label: "Yes",
                                                    onClick: () => {
                                                      Notiflix.Loading.Dots(
                                                        "Please wait..."
                                                      );
                                                      PostApiCall.postRequest(
                                                        {
                                                          id: data.chitid,
                                                          clientstatus: "Closed",
                                                        },
                                                        "CloseAccount"
                                                      ).then((result) =>
                                                        result
                                                          .json()
                                                          .then((obj) => {
                                                            if (
                                                              result.status ===
                                                              200 ||
                                                              result.status ===
                                                              201
                                                            ) {
                                                              Notiflix.Loading.Remove();
                                                              Notiflix.Notify.Success(
                                                                "Account is  successfully closed."
                                                              );
                                                              window.location.reload();
                                                            } else {
                                                              Notiflix.Loading.Remove();
                                                              Notiflix.Loading.Failure(
                                                                obj.data
                                                              );
                                                            }
                                                          })
                                                      );
                                                    },
                                                  },
                                                  {
                                                    label: "No",
                                                    // onClick: () => alert('Click No')
                                                  },
                                                ],
                                              });
                                            }}
                                          >
                                            Close A/C
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              </div>
            </React.Fragment>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
